import { Injectable } from '@angular/core';
import { BaseService, HttpService } from '@app/core';
import { ID } from '@app/models';
import { SCData } from '@app/models/core/SCData';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Injectable()
export class ExerciseTaskService extends BaseService {
  public componentBaseUrl = '';

  constructor(private http: HttpService) {
    super();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  solveQuestion(questionId: ID, model: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <Observable<SCData<any>>>(
      this.http.patch(`${this.componentBaseUrl}/${questionId}/solve`, model)
    );
  }

  bookmarkQuestions(questionId: ID) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <Observable<SCData<any>>>(
      this.http.patch(`${this.componentBaseUrl}/${questionId}/mark`, null)
    );
  }
  // saveText(model: Text) {
  //   return <Observable<SCData<ShellMenu>>>this.http.post(`/texts/texts`, model);
  // }
}
